import React from 'react';
import classnames from 'classnames';

export interface Props {
  htmlFor: string;
  className?: string;
}

export default class Label extends React.PureComponent<Props> {
  render() {
    return <label {...this.props} className={classnames('text-inherit mb-2', this.props.className)} />;
  }
}
